import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function TrendingArticles() {
  const { t } = useTranslation();
  const trending = articles.slice(0, 6);

  return (
    <section className="w-full bg-background-50 py-10 md:py-14 px-4 md:px-8 lg:px-12">
      <div className="mb-8 md:mb-10">
        <h2 className="text-2xl md:text-4xl font-light font-heading text-foreground-950 mb-2">
          {t('trendingTitle')}
        </h2>
        <p className="text-sm text-foreground-600">{t('trendingSubtitle')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {trending.map((article, index) => (
          <ArticleCard key={article.id} article={article} variant={index === 0 ? 'featured' : 'default'} />
        ))}
      </div>
    </section>
  );
}